import { render, staticRenderFns } from "./wxreSubmit.vue?vue&type=template&id=21d3c663"
import script from "./wxreSubmit.vue?vue&type=script&lang=js"
export * from "./wxreSubmit.vue?vue&type=script&lang=js"
import style0 from "./wxreSubmit.vue?vue&type=style&index=0&id=21d3c663&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports